import React from "react"
import YouTube from "react-youtube"
import Slider from "react-slick"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import ModalVideo from "../modal-video/modal-video"
import "./steps-product.scss"

const StepsProduct = ({ steps, mobile, setModalActive }) => {
  var settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <div className="f-StepsProduct">
      <TitleTab
        className={"f-TitleTab f-TitleTab-pink"}
        title={"Ponértelo es fácil"}
      />
      <div>
        {/* {!mobile && (
          <div
            onClick={() => handleRedirectVideo(steps[0].video)}
            className="f-StepsProduct-slider-itemVideo f-StepsProduct-slider-itemVideo-pc"
          >
            <img
              alt={steps[0].previsualizacionVideo.description}
              src={steps[0].previsualizacionVideo.file.url}
            />
            <div className="f-StepsProduct-slider-itemVideo-description">
              <span className="icon-play" />
              <p>¿Cómo se usa un tampon?</p>
            </div>
          </div>
        )} */}
        <Slider {...settings} className="f-StepsProduct-slider">
          {steps.map((info, index) => {
              return (
                <div key={index}>
                  <div className="f-StepsProduct-slider-item">
                    <img
                      alt={info.imagenPaso.description}
                      src={info.imagenPaso.file.url}
                    />
                    <h3>{info.numeroDePaso}</h3>
                    <p>{info.descripcionPaso.descripcionPaso}</p>
                  </div>
                </div>
              )
          })}
        </Slider>       
      </div>
    </div>
  )
}

export default StepsProduct
